import { useState, useEffect } from "react"

export function useDeviceDetection() {
  const [deviceInfo, setDeviceInfo] = useState({
    isMobile: false,
    isTablet: false,
    isDesktop: false,
  })

  useEffect(() => {
    const detectDevice = () => {
      const userAgent = navigator.userAgent.toLowerCase()
      const isMobile = /android|webos|iphone|ipod|blackberry|iemobile|opera mini/i.test(userAgent)
      const isTablet = /ipad|android(?!.*mobile)|tablet/i.test(userAgent)
      const isDesktop = !isMobile && !isTablet

      setDeviceInfo({
        isMobile,
        isTablet,
        isDesktop,
      })
    }

    detectDevice()

    // Listen for orientation changes on mobile devices
    window.addEventListener("orientationchange", detectDevice)
    window.addEventListener("resize", detectDevice)

    return () => {
      window.removeEventListener("orientationchange", detectDevice)
      window.removeEventListener("resize", detectDevice)
    }
  }, [])

  return deviceInfo
}
